export type Role = 'admin' | 'operator' | 'viewer';

export interface User {
  username: string;
  role: Role;
  fullName?: string;
  email?: string;
}

/**
 * Rol → yetki matrisi. Tek doğruluk kaynağı backend'dir (aynı kural
 * server/app/security.py'de); burada yalnız arayüzü şekillendirmek için.
 */
export interface Claims {
  /** Yeniden başlat / kurtarma gibi cihaz işlemleri */
  ops: boolean;
  /** Gömülü SSH terminali */
  ssh: boolean;
  /** Force install */
  force: boolean;
  /** İmaj profili atama */
  assign: boolean;
  /** Cihaz kimliği düzenleme */
  edit: boolean;
  /** Marka & imaj tanımları + sağlık eşikleri */
  brands: boolean;
  /** Kullanıcı & rol yönetimi */
  users: boolean;
  /** Salt-okunur rol mü */
  viewer: boolean;
}

export function deriveClaims(role: Role): Claims {
  const notViewer = role !== 'viewer';
  const admin = role === 'admin';
  return {
    ops: notViewer,
    ssh: notViewer,
    force: notViewer,
    assign: notViewer,
    edit: notViewer,
    brands: admin,
    users: admin,
    viewer: !notViewer,
  };
}

export const ROLE_LABELS: Record<Role, string> = {
  admin: 'admin',
  operator: 'operatör',
  viewer: 'izleyici',
};

export const ROLE_ICONS: Record<Role, string> = {
  admin: 'ti ti-shield-check',
  operator: 'ti ti-tool',
  viewer: 'ti ti-eye',
};

export const ROLE_DESCRIPTIONS: Record<Role, string> = {
  admin: 'Tüm işlemler, marka ve kullanıcı yönetimi',
  operator: 'Cihaz işlemleri ve SSH · kullanıcı yönetimi yok',
  viewer: 'Salt okunur · işlem ve SSH yok',
};
